import { Component, OnInit } from '@angular/core';
import {JbDefer} from '../../../../jb-ui-lib/src/lib/jb-defer/jb-defer';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-jb-loading-spinner-demo',
  templateUrl: './jb-loading-spinner-demo.component.html',
  styleUrls: ['./jb-loading-spinner-demo.component.scss']
})
export class JbLoadingSpinnerDemoComponent implements OnInit {





  constructor() {
    this.loadingPromise = new Promise(resolve => setTimeout(resolve, 5000));
  }
  public name = jbLoadingSpinnerDoc.name;
  public desc = jbLoadingSpinnerDoc.desc;
  public api = jbLoadingSpinnerDoc.api;
  public instance = jbLoadingSpinnerDoc.instance;

  public directiveInstance = `<div [jbLoadingSpinner]="loadingPromise"></div>`;
  public cssInstance = `<span class="jb-loading-spinner"></span>`;
  public overlayExample = `<div [jbLoadingSpinner]="loadingPromise">
  <div>....</div>
  <div>....</div>
  <div>....</div>
</div>`;
  public cssReset = `$loading-spinner-color: $primary_color !default;`;

  public loadingPromise;
  public promiseDef;
  public loadOn = false;
  public loadObs = new Subject();


  // ---- This is the logic to manage autogenerated code example ----
  public brStr = `\n`;
  public bsStr = `\n             `;
  public customCompCode = `<jb-loading-spinner></jb-loading-spinner>`;
  public compConf: any = {
    size: 'xs',
    isCenter: false,
    centerPos: 'center',
    triggerType: 'promise',
  };

  public customCompCode2 = `<jb-loading-spinner></jb-loading-spinner>`;

  public sizeCss = {
   sm: `<jb-loading-spinner class="sm"></jb-loading-spinner>`,
   md: `<jb-loading-spinner class="md"></jb-loading-spinner>`,
   lg: `<jb-loading-spinner class="lg"></jb-loading-spinner>`,
   xl: `<jb-loading-spinner class="xl"></jb-loading-spinner>`,
  };

  public centerCss = {
   top    : `<jb-loading-spinner class="center-top"></jb-loading-spinner>`,
   right  : `<jb-loading-spinner class="center-right"></jb-loading-spinner>`,
   left   : `<jb-loading-spinner class="center-left"></jb-loading-spinner>`,
   bottom : `<jb-loading-spinner class="center-bottom"></jb-loading-spinner>`,
  };
  public upComp = () => {
    this.customCompCode = `<jb-loading-spinner `;

    let compClasses = '';
    if (this.compConf.size !== 'xs') { compClasses += (!!compClasses.length ? ' ' : '') + this.compConf.size; }
    if (this.compConf.isCenter)      { compClasses += (!!compClasses.length ? ' ' : '') + this.compConf.centerPos; }
    if (!!compClasses) {
      this.customCompCode += `class="${compClasses}"`;
    }
    this.customCompCode += (`>` + `</jb-loading-spinner>`);
  }
  public upComp2 = () => {
    this.customCompCode2 = `<jb-loading-spinner `;

    let compClasses = '';
    if (this.compConf.size !== 'xs') { compClasses += (!!compClasses.length ? ' ' : '') + this.compConf.size; }
    if (this.compConf.isCenter)      { compClasses += (!!compClasses.length ? ' ' : '') + this.compConf.centerPos; }
    if (!!compClasses) {
      this.customCompCode2 += `class="${compClasses}"`;
    }
    this.customCompCode2 += (`>` + `</jb-loading-spinner>`);
  }

  ngOnInit() {
    this.upComp();
  }

  generatePromise = () => {
    this.promiseDef = new JbDefer();
    return this.promiseDef.promise;
  }

  generateObs = () => new Subject();

}


export const jbLoadingSpinnerDoc = {
  name    : `jb-loading-spinner`,
  uiType  : 'component',
  desc    : `Generates an element with a spinning circle to represent a loading status`,
  api     : `[jbLoadingSpinner]   It can be either a boolean, a promise or an observable`,
  instance: `<jb-loading-spinner></jb-loading-spinner>`,
  demoComp: JbLoadingSpinnerDemoComponent
};
